import * as d3 from 'd3'

/*
  distance: Number
  arrow: Bool
  links: Object
  isLinkDescription: Bool,
  isRefresh: Bool,
  isZoom: Bool
*/

var nodes = []
var links = []
var options = null
var colors = [
  '#000000', '#607D8B', '#9E9E9E', '#673AB7', '#3F51B5',
  '#2196F3', '#03A9F4', '#00BCD4', '#009688', '#4CAF50',
  '#8BC34A', '#CDDC39', '#FFEB3B', '#FFC107', '#FF9800',
  '#FF5722', '#795548', '#9C27B0', '#E91E63', '#F44336'
]

const createDescription = (distinct, nodeDistinct) => {
  if (document.querySelector('svg').parentNode.querySelectorAll('div.desc').length > 0) {
    document.querySelector('svg').parentNode.querySelector('div.desc').remove()
  }
  var svg = document.querySelector('svg')
  var div = document.createElement('div')
  div.className = 'desc'
  div.style.backgroundColor = 'transparent'
  const linkHeight = ((Object.keys(distinct).length * 20) + 10)
  const nodeHeight = nodeDistinct ? ((Object.keys(nodeDistinct).length * 20) + 10) : 25
  div.style.marginTop = '-' + (linkHeight + nodeHeight - 30) + 'px'
  div.style.verticalAlign = 'top'

  var maxWidth = 1
  // for node
  if (nodeDistinct) for (let key in nodeDistinct) {
    var line = document.createElement('div')
    if (nodeDistinct[key].length > maxWidth) maxWidth = nodeDistinct[key].length
    line.innerText = key.toUpperCase() + ' : ' + nodeDistinct[key]
    line.style.textAlign = 'right'
    line.style.fontSize = '8px'
    div.appendChild(line)
  }
  div.appendChild(document.createElement('br'))
  // for link
  for (let key in distinct) {
    line = document.createElement('div')
    if (distinct[key].length > maxWidth) maxWidth = distinct[key].length
    line.innerText = key
    line.style.borderBottom = '2px solid ' + distinct[key]
    line.style.textAlign = 'right'
    line.style.fontSize = '8px'
    div.appendChild(line)
  }
  if (maxWidth < 10) maxWidth = 15
  div.style.width = (maxWidth * 5.5) + 'px'
  div.style.marginLeft = (svg.parentNode.clientWidth - (maxWidth * 6) - 5) + 'px'
  svg.insertAdjacentElement('afterend', div)
}

const createRefresh = () => {
  if (document.querySelector('svg').parentNode.querySelectorAll('span.icon').length > 0) return
  var tabButton = document.querySelector('svg').parentNode.querySelectorAll('a').length
  var svg = document.querySelector('svg')
  var span = document.createElement('span')
  span.className = 'icon'
  var icon = document.createElement('i')
  icon.className = 'mdi mdi-autorenew mdi-24px mdi-dark'
  icon.style.marginLeft = (svg.clientWidth - 20 - (tabButton * 105)) + 'px'
  icon.style.marginTop = '-' + (svg.clientHeight + 30) + 'px'
  icon.onclick = () => {
    refresh()
  }
  span.appendChild(icon)
  svg.insertAdjacentElement('beforebegin', span)
}

const refresh = () => {
  options.isDescription = false
  options.isRefresh = false
  create(nodes, links, options)
}

const create = (_nodes, _links, _options) => {
  d3.selectAll('svg > *').remove()
  nodes = _nodes.slice()
  links = _links.slice()
  options = JSON.parse(JSON.stringify(_options))
  var linkColor = {}
  var nodeColor = {}
  var _colors = colors.slice()
  for (let l of links) {
    if (linkColor[l.title] === undefined) {
      linkColor[l.title] = l.color ? l.color : _colors.pop()
    }
    if (nodeColor[l.source] === undefined) {
      nodeColor[typeof (l.source) === 'string' ? l.source : l.source.id] = linkColor[l.title]
    }
  }
  if (options.isRefresh === true) createRefresh()
  if (options.nodeDescription) {
    var distinctDesc = {}
    for (let n of nodes) {
      if (options.nodeDescription[n.label.toLowerCase()]) {
        distinctDesc[n.label] = options.nodeDescription[n.label.toLowerCase()]
      }
    }
    if (options.isLinkDescription === true) createDescription(linkColor, distinctDesc)
    else createDescription(linkColor)
  }
  else {
    if (options.isLinkDescription === true) createDescription(linkColor)
  }
  var svg = d3.select('svg')
  var container = svg.append("g")

  container.datum({ x: 0, y: 0 }).call(d3.drag()
    .on("drag", function (d, i) {
      d3.select(this).attr("transform", "translate(" + (d.x = d3.event.x) + "," + (d.y = d3.event.y) + ")");
    }))
  var width = svg.node().getBoundingClientRect().width
  var height = svg.node().getBoundingClientRect().height
  if (options.arrow) {
    svg.append('defs').append('marker')
      .attr('id', 'arrowhead')
      .attr('viewBox', '0 -5 10 10')
      .attr('refX', 8)
      .attr('refY', 0)
      .attr('orient', 'auto')
      .attr('markerWidth', 5)
      .attr('markerHeight', 5)
      .attr('xoverflow', 'visible')
      .append('svg:path')
      .attr('d', 'M0,-5L10,0L0,5')
      .attr('fill', '#999')
      .style('stroke', 'none')
  }
  var zoom = d3.zoom().scaleExtent([.1, 2]).on('zoom', function () {
    container.attr('transform', d3.event.transform)
  })
  if (options.isZoom) svg.call(zoom)
  var simulation = d3.forceSimulation()
    .force('charge', d3.forceManyBody().strength(-20))
    .force('link', d3.forceLink().id(function (d) { return d.id }).distance(options.distance ? options.distance : 100).strength(1))
    .force('center', d3.forceCenter(width / 2, height / 2))

  var link = container.append("g").selectAll('.link')
    .data(links)
    .enter()
    .append('line')
    .style('stroke-opacity', 0.6)
    .style('stroke-width', '2px')
    .style('stroke', function (d) { return linkColor[d.title] })
    .attr('marker-end', 'url(#arrowhead)')
    .attr("class", "links")
    .on('mouseover', function (d) {
      var line = d3.select(this)
      line.style('stroke-width', 4)
      line.style('stroke-opacity', 0.5)
    })
    .on('mouseout', function (d) {
      var line = d3.select(this)
      line.style('stroke-width', 2)
      line.style('stroke-opacity', 0.6)
    })

  link.append('title')
    .text(function (d) { return d.title || '' })

  var edgepaths = container.append("g").selectAll('.edgepath')
    .data(links)
    .enter()
    .append('path')
    .attr('class', 'edgepath')
    .attr('fill-opacity', 1)
    .attr('stroke-opacity', 0)
    .attr('id', function (d, i) { return 'edgepath' + i })
    .style('pointer-events', 'none')

  var edgelabels = container.append("g").selectAll('.edgelabel')
    .data(links)
    .enter()
    .append('text')
    .style('pointer-events', 'none')
    .attr('class', 'edgelabel')
    .attr('id', function (d, i) { return 'edgelabel' + i })
    .attr('font-size', 8)
    .attr('fill', '#9E9E9E')

  edgelabels.append('textPath')
    .attr('xlink:href', function (d, i) { return '#edgepath' + i })
    .style('text-anchor', 'middle')
    .style('pointer-events', 'none')
    .attr('startOffset', '50%')
    .text(function (d) { return d.label || '' })

  var node = container.append("g").selectAll('.node')
    .data(nodes)
    .enter()
    .append('g')
    .attr('class', 'node')
    .call(d3.drag()
      .on('start', function (d) {
        if (!d3.event.active) simulation.alphaTarget(0.3).restart()
        d3.event.subject.fx = d3.event.subject.x;
        d3.event.subject.fy = d3.event.subject.y;
      })
      .on('drag', function (d) {
        d3.event.subject.fx = d3.event.x;
        d3.event.subject.fy = d3.event.y;
      })
      .on('end', function (d) {
        if (!d3.event.active) simulation.alphaTarget(0);
        d3.event.subject.fx = null;
        d3.event.subject.fy = null;
      })
    )
    .on('mouseover', function (d) {
      var circle = d3.select(this).select('circle')
      circle.attr('stroke-width', 3)
      circle.attr('stroke-opacity', 0.5)
      circle.attr('stroke', circle.attr('style') ? circle.attr('style').replace('fill: ', '').replace(';', '') : '#90CAF9')

      var rect = d3.select(this).select('rect')
      rect.style('fill-opacity', 1)
    })
    .on('mouseout', function (d) {
      var circle = d3.select(this).select('circle')
      circle.attr('stroke-width', 0)
      circle.attr('stroke-opacity', 0)

      var rect = d3.select(this).select('rect')
      rect.style('fill-opacity', function (d) { return d.isHighlight ? 1 : 0.3 })
    })

  node.append('defs')
    .append('pattern')
    .attr('id', function (d, i) { return d.id })
    .attr('patternUnits', 'userSpaceOnUse')
    .attr('x', -20)
    .attr('y', -20)
    .attr('width', 40)
    .attr('height', 40)
    .append('image')
    .attr('xlink:href', function (d) { return d.img })
    .attr('width', 40)
    .attr('height', 40)

  node.append("rect")
    .attr("width", function (d) { return d.type === 'property' ? 100 : 0 })
    .attr("height", function (d) { return d.type === 'property' ? 20 : 0 })
    .style('stroke', function (d, i) { return nodeColor[d.id] })
    .text(function (d) { return d.label })
    .style("fill-opacity", function (d) { return d.isHighlight ? 1 : 0.3 })
    .style("fill", "#F44336")
    .attr('x', -50)
    .attr('y', -10)
    .attr('rx', 3)
    .attr('rx', 3)
  node.append('circle')
    .attr('r', function (d) {
      return d.type === 'property' ? 0 : 20
    })
    .style('stroke', function (d, i) { return nodeColor[d.id] })
    .attr('stroke-opacity', 0)
    .style('fill', function (d, i) { return d.img ? 'url(#' + d.id + ')' : (d.color ? d.color : nodeColor[d.id]) })

  node.append('title')
    .text(function (d) { return d.id || '' })

  node.append('text')
    .attr('dy', function (d) { return d.type === 'property' ? -12 : -22 })
    .attr('font-size', function (d) { return d.size ? 14 : 10 })
    .attr('text-anchor', 'middle')
    .text(function (d) {
      return d.type === 'property' ? (d.label && d.label.toLowerCase()) : (d.label && d.label.toUpperCase())
    })
  // text for rect
  node.append('text')
    .attr('dy', 3)
    .attr('font-size', function (d) { return d.size ? 14 : 10 })
    .attr('text-anchor', 'middle')
    .style("fill", "#fff")
    .text(function (d) { return d.type === 'property' ? d.value : '' })

  simulation
    .nodes(nodes)
    .on('tick', function () {
      link
        .attr('x1', function (d) { return d.source.x })
        .attr('y1', function (d) { return d.source.y })
        .attr('x2', function (d) { return d.target.x })
        .attr('y2', function (d) { return d.target.y })

      node
        .attr('transform', function (d) { return 'translate(' + d.x + ', ' + d.y + ')' })

      edgepaths.attr('d', function (d) {
        return 'M ' + d.source.x + ' ' + d.source.y + ' L ' + d.target.x + ' ' + d.target.y
      })

      edgelabels.attr('transform', function (d) {
        if (d.target.x < d.source.x) {
          var bbox = this.getBBox()
          var rx = bbox.x + bbox.width / 2
          var ry = bbox.y + bbox.height / 2
          return 'rotate(180 ' + rx + ' ' + ry + ')'
        } else {
          return 'rotate(0)'
        }
      })
    })
  simulation.force('link').links(links)
}

export default {
  create,
  colors
}



// WEBPACK FOOTER //
// ./src/lib/components/d3.js